module.exports = __webpack_public_path__ + "static/diverse-group-of-women-mobile.b4c36274.webp";